import { render, staticRenderFns } from "./ProductInfoTakeOrder.vue?vue&type=template&id=5024408f&scoped=true&"
import script from "./ProductInfoTakeOrder.vue?vue&type=script&lang=js&"
export * from "./ProductInfoTakeOrder.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoTakeOrder.vue?vue&type=style&index=0&id=5024408f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024408f",
  null
  
)

export default component.exports